module.exports = __webpack_public_path__ + "static/media/paddle-court.4d739f03.webp";